import { useDraftStore } from '@/lib/draftStore';
import { FormField } from '@/components/ui/FormField';
import { MoneyInput } from '@/components/ui/MoneyInput';
import { MAX_BID_STEP } from '@/lib/bidLimits';
import { DurationPicker } from '../DurationPicker';

export const Step3Pricing = () => {
  const draft = useDraftStore((s) => s.draft);
  const update = useDraftStore((s) => s.update);

  return (
    <>
      <FormField
        label="Стартовая цена"
        required
        hint="С этой суммы начнутся торги"
      >
        <MoneyInput
          value={draft.start_price}
          onChange={(v) => update({ start_price: v })}
        />
      </FormField>

      <FormField
        label="Минимальный шаг ставки"
        required
        hint="От 1 ₽ до 2 000 ₽ — на сколько минимум вырастет каждая следующая ставка"
      >
        <MoneyInput
          value={draft.min_step}
          onChange={(v) => update({ min_step: v })}
        />
      </FormField>

      <FormField
        label="Купить сразу (опционально)"
        hint={
          draft.buy_now_price === null
            ? 'Оставь пустым, если не хочешь Выкуп сразу'
            : 'Если покупатель заплатит эту сумму — аукцион закроется мгновенно'
        }
      >
        <MoneyInput
          value={draft.buy_now_price ?? 0}
          onChange={(v) => update({ buy_now_price: v === 0 ? null : v })}
          placeholder="0"
        />
      </FormField>

      <FormField label="Продолжительность" required>
      <DurationPicker
          value={draft.duration_minutes}
          onChange={(m) => update({ duration_minutes: m })}
        />
      </FormField>
    </>
  );
};

export const validateStep3 = (draft: {
  start_price: number;
  min_step: number;
  buy_now_price: number | null;
}): string | null => {
  if (draft.start_price < 1_00) return 'Стартовая цена должна быть больше 1 ₽';
  if (draft.min_step < 1_00) return 'Шаг должен быть больше 1 ₽';
  if (draft.min_step > MAX_BID_STEP) return 'Шаг не может быть больше 2 000 ₽';
  if (
    draft.buy_now_price !== null &&
    draft.buy_now_price !== 0 &&
    draft.buy_now_price <= draft.start_price
  ) {
    return 'Цена мгновенного выкупадолжна быть больше стартовой цены';
  }
  return null;
};